module.exports = __webpack_public_path__ + "static/media/infobip.6a5ad7c7.png";